import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import AclContextProvider from '../../../../Acl/Components/AclContextProvider';
import CaseTypeList from './CaseTypeList';

loadDOMComponent({
	selector: 'react-manager-case-type-list',
	callback: ({ container, context, props }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const healthPlanCode = container.getAttribute('healthPlanCode');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<CaseTypeList
							workplaceId={workplaceId}
							healthPlanCode={healthPlanCode}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
